import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { LoyaltyModels } from "./loyalty.models";

export namespace LoyaltyApi {
export const listRewards = () => { 
    return AppRestClient.get( 
        { resSchema: LoyaltyModels.ListRewardsResponseSchema }, 
        `/loyalty/rewards`,
        
    )
};

export const getPoints = () => { 
    return AppRestClient.get( 
        { resSchema: LoyaltyModels.PointsSummarySchema }, 
        `/loyalty/points`,
        
    )
};

}
